import React from 'react';
import { useDispatch } from 'react-redux';
import {
  ValidMe,
  forceValidation,
  clearAllValidationErrors,
  isStringEmpty,
} from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { updateCallerEntryForm, sendEmailInstructions } from '../../../../actions/waitingArea.js';
import { Checkbox, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function CenterPanelCallerEntry(props) {
  const dispatch = useDispatch();

  const callerEntryFormUpdated = (updatedObject) => {
    let updatedBeforeCallsForm = objectAssign({}, props.callerEntryPointForm, updatedObject);
    return updatedBeforeCallsForm;
  };

  const shortURLChange = (value) => {
    // Replace all forward slashes with single forward slash
    value = value.replace(/[\/]{1,}/g, '/');

    let updatedProperties = {
      shortUrl: value.substr(0, 128),
    };
    dispatch(updateCallerEntryForm(callerEntryFormUpdated(updatedProperties)));
  };

  const customURLChange = (value) => {
    let updatedProperties = {
      customUrl: value,
    };
    dispatch(updateCallerEntryForm(callerEntryFormUpdated(updatedProperties)));
  };

  const emailInstructionsBtnClicked = () => {
    dispatch(sendEmailInstructions(props.waitingArea.id));
  };

  const checkboxChange = () => {
    let updatedProperties = {
      isWaitingAreaPublic: !props.callerEntryPointForm.isWaitingAreaPublic,
      isDirty: true,
    };
    dispatch(updateCallerEntryForm(callerEntryFormUpdated(updatedProperties)));
  };

  let yourOwnPageTxt = (
    <ValidMe
      validmefor={'httpOrHttpsURL@canBeEmpty'}
      group="callerEntryPage"
      disableValidWhenBlur={true}
      fieldClasses="no-caption-input-field"
      condition={() => {
        return props.callerEntryPointForm.customUrl.length <= props.callerEntryPointForm.maxUrlLength;
      }}
      validmemessage={APP.LANGUAGE.Errors.URLOverLimit.replace('##limit##', props.callerEntryPointForm.maxUrlLength)}
    >
      <Txt
        tabIndex="2"
        focusme="true"
        noTitle
        onChange={customURLChange}
        value={props.callerEntryPointForm.customUrl}
        notRenderPlaceholderAsTitle={true}
        placeholder={APP.LANGUAGE.CallerEntryModal.YourPagePlaceholder}
        fieldClasses="no-caption-input-field mrtxs"
      />
    </ValidMe>
  );

  let aAPageTxt = (
    <ValidMe
      validmefor="shortURLPath@urlExtenstionIsInUse"
      group="callerEntryPage"
      condition={() => {
        return props.callerEntryPointForm.urlExtenstionIsInUse;
      }}
      disableValidWhenBlur={true}
    >
      <Txt
        tabIndex="4"
        fieldClasses="inline-input-field"
        notRenderPlaceholderAsTitle={true}
        onChange={shortURLChange}
        name="AAHostedURLInput"
        noTitle
        value={props.callerEntryPointForm.shortUrl}
      />
    </ValidMe>
  );

  return (
    <div className="ui form">
      <div className="title-sms mrbs">{htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.BtnCaption))}</div>
      <div className="inline-flex center-flex mrbm">
        <button className="ui icon button color-button color-white mrrs" onClick={emailInstructionsBtnClicked}>
          <i className="envelope icon" />
        </button>
        <div className="title-sms">{APP.LANGUAGE.CallerEntryModal.BtnLabel}</div>
      </div>
      <hr style={{ border: '1px solid #e6e6e6' }} />
      <div className="title-sms mrbs mrtm">
        {htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.YourWebsiteCaption1))}
      </div>
      {yourOwnPageTxt}
      <div className="title-sms mrbm mrts">
        {htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.YourWebsiteCaption2))}
      </div>
      <hr style={{ border: '1px solid #e6e6e6' }} />
      <div className="title-sms mrbs mrtm">
        <span>
          {htmlToReactParser.parse(
            xss(
              `${APP.LANGUAGE.CallerEntryModal.DefaultURLCaption0} ${APP.LANGUAGE.CallerEntryModal.DefaultURLCaption1}`
            )
          )}
        </span>
        <span>
          (
          <a
            href={
              props.callerEntryPointForm.longUrl ||
              `${props.waitingArea.shortUrlDomain}${props.callerEntryPointForm.shortUrl}`
            }
            className="no-animation call-entry-page-url mrts"
            target="_blank"
          >
            {APP.LANGUAGE.CallerEntryModal.DefaultURLCaption2}
          </a>
          )
        </span>
      </div>
      <div className="center-flex display-flex one-line-input-field mrbm">
        <div className="title-sms small-margin wrap-link mrbxs mrtxs">{props.waitingArea.shortUrlDomain}</div>
        {aAPageTxt}
      </div>
      {props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
        ''
      ) : (
        <hr style={{ border: '1px solid #e6e6e6' }} />
      )}
      <Container fluid as={Media} greaterThanOrEqual="computer" className="center-flex display-flex mrtm">
        {props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
          ''
        ) : (
          <React.Fragment>
            <Checkbox
              tabIndex="5"
              className="ui checkbox mrrm"
              checked={props.callerEntryPointForm.isWaitingAreaPublic}
              onChange={checkboxChange}
            />
            <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.AllowAccessToWA))}</span>
          </React.Fragment>
        )}
      </Container>
      <Container fluid as={Media} lessThan="computer" className="center-flex display-flex center-flex mrtm mrbl">
        {props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
          ''
        ) : (
          <React.Fragment>
            <Checkbox
              tabIndex="5"
              className="ui checkbox mrrxl"
              checked={props.callerEntryPointForm.isWaitingAreaPublic}
              onChange={checkboxChange}
            />
            <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.AllowAccessToWA))}</span>
          </React.Fragment>
        )}
      </Container>
    </div>
  );
}
